import { useState, useEffect } from "react";

function useScrollToTop() {
    const [stick, setStick] = useState(false);

    useEffect(() => {
        const scrollHandler = () => {
            const aboutSection = document.querySelector(".about__four.section-padding");

            if (!aboutSection) {
                setStick(false);
                return;
            }

            const sectionRect = aboutSection.getBoundingClientRect();
            const sectionTop = sectionRect.top + window.scrollY;
            const sectionReached = window.scrollY >= sectionTop;

            setStick(sectionReached);
        };

        scrollHandler();
        window.addEventListener("scroll", scrollHandler);

        return () => {
            window.removeEventListener("scroll", scrollHandler);
        };
    }, []);

    return { stick, onClickHandler: () => window.scrollTo({ top: 0, behavior: "smooth" }) };
}

export default useScrollToTop;